import { Link } from "react-router-dom";
import { FileText, Download, BookOpen, ArrowLeft } from "lucide-react";

/**
 * Central de Documentação SOEASY
 * Acesso público aos PDFs institucionais.
 */
export default function Documentacao() {
  const docs = [
    {
      titulo: "Documentação Técnica Completa",
      desc: "Estado atual da aplicação — arquitetura, módulos, endpoints, coleções, credenciais. Use para consulta ou rollback.",
      arquivo: "/docs/SOEASY-Documentacao-Tecnica.pdf",
      badge: "TÉCNICO",
      color: "#22D3EE",
      icon: FileText,
    },
    {
      titulo: "Manual do Colaborador",
      desc: "Guia prático de uso do sistema no dia a dia. Para repassar a todos os colaboradores admitidos.",
      arquivo: "/docs/SOEASY-Manual-Colaborador.pdf",
      badge: "COLABORADOR",
      color: "#B28F4B",
      icon: BookOpen,
    },
  ];

  return (
    <div className="min-h-screen bg-[#0A0B1A]">
      <header className="bg-gradient-to-r from-[#1A1D42] to-[#252952] border-b border-[#B28F4B]/25">
        <div className="max-w-[1200px] mx-auto px-5 py-4 flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-[#0A0B1A] border-2 border-[#B28F4B] flex items-center justify-center">
            <FileText size={20} className="text-[#B28F4B]" />
          </div>
          <div className="flex-1">
            <div className="text-[#B28F4B] font-bold font-heading text-lg">SOEASY · Central de Documentação</div>
            <div className="text-white/60 text-[10px] uppercase tracking-widest">PDFs institucionais e manuais</div>
          </div>
          <Link to="/login" data-testid="link-voltar-login" className="px-3 py-1.5 rounded-md border border-[#B28F4B]/40 text-white text-xs font-bold uppercase tracking-widest flex items-center gap-1">
            <ArrowLeft size={13}/> Login
          </Link>
        </div>
      </header>

      <main className="max-w-[1000px] mx-auto p-8">
        <div className="text-center mb-10">
          <div className="text-[#B28F4B] font-heading text-3xl font-bold mb-2">Documentos do Sistema</div>
          <div className="text-[#A1A4C7] text-sm">Baixe os PDFs oficiais da plataforma SOEASY</div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {docs.map((d) => (
            <a
              key={d.arquivo}
              href={d.arquivo}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`download-${d.badge.toLowerCase()}`}
              className="group bg-gradient-to-br from-[#131532] to-[#0A0B1A] border border-[#B28F4B]/25 rounded-2xl p-6 hover:border-[#B28F4B] transition-all"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-14 h-14 rounded-xl border-2 flex items-center justify-center"
                     style={{ borderColor: d.color, background: d.color + "15" }}>
                  <d.icon size={26} style={{ color: d.color }} />
                </div>
                <span className="px-2.5 py-1 rounded-md text-[9px] font-bold uppercase tracking-widest border"
                      style={{ borderColor: d.color + "60", color: d.color, background: d.color + "10" }}>
                  {d.badge}
                </span>
              </div>
              <div className="text-white font-heading font-bold text-lg mb-2 leading-tight">{d.titulo}</div>
              <div className="text-[#A1A4C7] text-xs leading-relaxed mb-4">{d.desc}</div>
              <div className="flex items-center gap-2 text-[#B28F4B] text-xs font-bold uppercase tracking-widest group-hover:text-[#D4AF37] transition">
                <Download size={13} /> Baixar PDF
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 p-5 bg-[#131532]/60 border border-[#B28F4B]/20 rounded-2xl text-center">
          <div className="text-[#B28F4B] text-[10px] font-bold uppercase tracking-[0.25em] mb-2">Uso Interno</div>
          <div className="text-white/70 text-xs">
            Os documentos são de uso confidencial do Grupo SOEASY.<br/>
            Compartilhe apenas com colaboradores devidamente cadastrados.
          </div>
        </div>
      </main>
    </div>
  );
}
